export function prepeareLanes(lanes, stages) {
  if (lanes && stages) {
    const boardLanes = [];

    stages.forEach((currentLane) => {
      boardLanes.push(currentLane);
    })
    return boardLanes;
  }

  return null;
}

export function getColumnNames(arrData) {
  const arrColumns = [];
  if (arrData) {
    arrData.forEach((currentColumn) => {
      arrColumns.push({
        id: currentColumn.id,
        name: currentColumn.label,
      });
    })
  }

  return arrColumns;
}

export function findById(data, id) {
  if (data) {
    data = data.filter(i => i)

    for (let i = data.length; i--;) {
      if (data[i].id === id) {
        return data[i];
      }
    }
  }
}

export function addTasksToStages(tasks, stages) {
  if (tasks && stages) {
    let dragbbleIdCounter = 1;
    stages.forEach(currentStage => {
      let id = parseInt(currentStage.id);
      currentStage.items = [];

      // Set items for stage
      for (let j = 0; j < tasks.length; j++) {
        if (id === parseInt(tasks[j].stage)) {
          currentStage.items.push(tasks[j]);
        }
      }
    })

    return stages;
  }
  return [];
}

// FIX: Move to server side
export function fixTasksData(tasks) {
  for (let i = 0; i < tasks.length; i++) {
    if (!tasks[i].id) {
      tasks[i].id = i;
    }
  }
  return tasks;
}

export function getItemsByLaneIds(items, laneIds) {
  const newItems = [];
  for (let i = 0; i < laneIds.length; i++) {
    for (let j = 0; j < items.length; j++) {
      if (laneIds[i] == items[j].lane) {
        newItems.push(items[j]);
      }
    }
  }
  return newItems;
}

export function filterBySearchWord(searchWord, items, extraFieldToShow = []) {
  if (searchWord) {
    const newItems = [];
    for (let i = 0; i < items.length; i++) {
      let taskName = items[i].task_name;
      let taskDescription = items[i].description;
      let customer = items[i].customer;
      let projectName = items[i].project_name;


      let field_54 = items[i].field_54;
      let field_38 = items[i].field_38;
      let field_37 = items[i].field_37;
      let field_36 = items[i].field_36;
      let field_35 = items[i].field_35;

      let extraFields = extraFieldToShow.map(extra => `extra_${extra.id}`);

      let needAdd = false;

      const tempSearchWord = searchWord.toLowerCase();

      extraFields.reduce((cur, extra) => {
        if (items[i][extra].indexOf(tempSearchWord) !== -1 ) {
          needAdd = true;
        }
      }, false)
      if (!needAdd && ( taskName ||
          taskDescription ||
          customer ||
          projectName ||
          field_54 ||
          field_38 ||
          field_37 ||
          field_36 ||
          field_35
          )) {
        taskName = taskName && taskName.toLowerCase();
        customer = customer && customer.toLowerCase();
        projectName = projectName && projectName.toLowerCase();
        taskDescription = taskDescription && taskDescription.toLowerCase() || '';

        field_54 = field_54 && field_54.toLowerCase();
        field_38 = field_38 && field_38.toLowerCase();
        field_37 = field_37 && field_37.toLowerCase();
        field_36 = field_36 && field_36.toLowerCase();
        field_35 = field_35 && field_35.toLowerCase();

        if (taskName.indexOf(tempSearchWord) !== -1 ||
            customer.indexOf(tempSearchWord) !== -1 ||
            (projectName && projectName.indexOf(tempSearchWord) !== -1) ||

            field_54.indexOf(tempSearchWord) !== -1 ||
            field_38.indexOf(tempSearchWord) !== -1 ||
            field_37.indexOf(tempSearchWord) !== -1 ||
            field_36.indexOf(tempSearchWord) !== -1 ||
            field_35.indexOf(tempSearchWord) !== -1 ||

            taskDescription && taskDescription.indexOf(tempSearchWord) !== -1) {
          needAdd = true;
        }
      }

      if (needAdd) {
        newItems.push(items[i]);
      }

    }
    return newItems;
  }

  return items;
}

export function getStageByTicketId(data, id) {
  for (let i = data.length; i--;) {
    if (data[i].label === id) {
      return data[i].id;
    }
  }
}

export function getLaneByTicketId(data, id) {
  for (let i = data.length; i--;) {
    if (data[i].task_id === id) {
      return data[i].lane;
    }
  }
}



// WEBPACK FOOTER //
// ./src/containers/Dashboard/data.js